var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-10" }, [
      _vm._m(0),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.round.name,
            expression: "round.name",
          },
        ],
        staticClass: "form-control",
        attrs: {
          type: "text",
          name: "name",
          maxlength: "50",
          disabled: _vm.disabled,
          placeholder: "Round Name",
        },
        domProps: { value: _vm.round.name },
        on: {
          change: _vm.update,
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.$set(_vm.round, "name", $event.target.value)
          },
        },
      }),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", [_c("h5", [_vm._v("Round Name")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }